import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { IgarashiCustomerAction } from "store/customer-resource/actions"
import { useFormik } from "formik"
import * as Yup from "yup"
import Select from "react-select"
import BranchesAction from "store/branch-resource/actions"
import { MetaTags } from "react-meta-tags"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import DateInput from "components/Common/DateInput"
import moment from "moment"
import SButton from "components/Common/Button"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"
import { IgarashiCustomerAPI } from "helpers/customer_backend_helper"

export default function DetailIgarashi() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      branchId: "",
      branchName: "",
      customerName: "",
      postalCode: "",
      prefectures: "",
      address: "",
      email: "",
      password: "",
      phone: "",
    },
    validationSchema: Yup.object({
      branchId: Yup.string().required("必須項目です。"),
      branchName: Yup.string().required("必須項目です。"),
      customerName: Yup.string().required("必須項目です。"),
      // postalCode: Yup.string().required("必須項目です。"),
      // prefectures: Yup.string().required("必須項目です。"),
      // address: Yup.string().required("必須項目です。"),
      email: Yup.string()
        .required("必須項目です。")
        .email("有効な電子メールである必須項目です。があります")
        .nullable(),
      // password: Yup.string().required("必須項目です。"),
      // phone: Yup.string().required("必須項目です。"),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(IgarashiCustomerAction.postData(values, callbackPost))
      } else {
        dispatch(
          IgarashiCustomerAction.putData(
            { ...values, id: params.id },
            callbackPut
          )
        )
      }
    },
  })

  const callbackPost = () => {
    history.push("/direct-management-individual-customer-management/")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/direct-management-individual-customer-management/")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(
        IgarashiCustomerAction.getDetail({ id: params.id }, callbackGetDetail)
      )
    }
  }, [params.id])

  React.useEffect(() => {
    dispatch(BranchesAction.getIgarashiList())
  }, [])

  const [filter, setFilter] = useState({
    orderNumber: "",
    orderDateFrom: "",
    orderDateTo: "",
  })

  const [data, setData] = useState({
    content: [],
    totalPages: 0,
    loading: false,
  })
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })
  const getDataFiles = async (id, params) => {
    setData({ ...data, loading: true })
    const res = await IgarashiCustomerAPI.getFile(id, params)

    setData({
      ...data,
      content: res.data.content,
      totalPages: res.data.totalPages,
      loading: false,
    })
  }

  const onChange = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onDelete = async idFile => {
    await IgarashiCustomerAPI.deleteFile(id, idFile)

    getDataFiles(params.id, {
      ...pagination,
      ...filter,
    })
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "受注ID",
        accessor: "orderNumber",
        disableSortBy: true,
      },
      {
        Header: "ファイル名",
        accessor: "categoryName",
        disableSortBy: true,
      },
      {
        Header: "ファイルカテゴリ",
        accessor: "fileName",
        disableSortBy: true,
      },

      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <>
              <a
                className="button me-2"
                style={{ padding: "8px 10px" }}
                href={cell.row.original.url}
                target="_blank"
                rel="noreferrer"
              >
                ダウンロード
              </a>
              <SButton onClick={() => onDelete(cell.row.id)} className="button">
                削除
              </SButton>
            </>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    if (params.id !== "add") {
      getDataFiles(params.id, {
        ...pagination,
        ...filter,
      })
    }
  }, [params.id])

  const onSearch = () => {
    getDataFiles(params.id, {
      ...pagination,
      ...filter,
    })
  }

  return (
    <>
      <MetaTags>
        <title>直営個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"直営個人顧客管理"} breadcrumbList={[]} />

          <Card>
            <CardBody>
              {store.customer.detailIgarashi.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "直営個人顧客詳細"
                          : "新規直営個人顧客追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      {params.id != "add" && (
                        <>
                          <br />
                          <Button
                            type="button"
                            className="button me-2"
                            onClick={() =>
                              history.push(
                                `/direct-management-individual-customer-management/${params.id}/history`
                              )
                            }
                          >
                            購入履歴
                          </Button>
                        </>
                      )}
                      <br />
                      <Button type="submit" className="button me-2">
                        保存
                      </Button>
                      <Button
                        type="button"
                        className="button"
                        onClick={() =>
                          history.push(
                            "/direct-management-individual-customer-management"
                          )
                        }
                      >
                        キャンセル
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="10">
                      <FormGroup row>
                        <Label sm="2">企業名・店舗名</Label>
                        <Col sm="4">
                          <Select
                            isLoading={store.branches.igarashiList.loading}
                            options={store.branches.igarashiList.data.map(
                              i => ({ value: i.id, label: i.branchName })
                            )}
                            defaultValue={{
                              value: validation.values.branchId,
                              label: validation.values.branchName,
                            }}
                            value={{
                              value: validation.values.branchId,
                              label: validation.values.branchName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("branchId", e.value)
                              validation.setFieldValue("branchName", e.label)
                            }}
                          />
                          <Input
                            name="branchId"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.branchId || ""}
                            invalid={
                              validation.touched.branchId &&
                              validation.errors.branchId
                                ? true
                                : false
                            }
                          />
                          {validation.touched.branchId &&
                          validation.errors.branchId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.branchId}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">名前</Label>
                        <Col sm="4">
                          <Input
                            name="customerName"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.customerName || ""}
                            invalid={
                              validation.touched.customerName &&
                              validation.errors.customerName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.customerName &&
                          validation.errors.customerName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.customerName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">電話番号</Label>
                        <Col sm="4">
                          <Input
                            name="phone"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.phone || ""}
                            invalid={
                              validation.touched.phone &&
                              validation.errors.phone
                                ? true
                                : false
                            }
                          />
                          {validation.touched.phone &&
                          validation.errors.phone ? (
                            <FormFeedback type="invalid">
                              {validation.errors.phone}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="12">住所</Label>
                        <Col sm="12" className="ms-4">
                          <FormGroup row>
                            <Label sm="2">郵便番号</Label>
                            <Col sm="4">
                              <Input
                                name="postalCode"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.postalCode || ""}
                                invalid={
                                  validation.touched.postalCode &&
                                  validation.errors.postalCode
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.postalCode &&
                              validation.errors.postalCode ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.postalCode}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label sm="2">都道府県</Label>
                            <Col sm="4">
                              <Input
                                name="prefectures"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.prefectures || ""}
                                invalid={
                                  validation.touched.prefectures &&
                                  validation.errors.prefectures
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.prefectures &&
                              validation.errors.prefectures ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.prefectures}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label sm="2">住所</Label>
                            <Col sm="8">
                              <Input
                                name="address"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.address || ""}
                                invalid={
                                  validation.touched.address &&
                                  validation.errors.address
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.address &&
                              validation.errors.address ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.address}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </FormGroup>
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">メールアドレス</Label>
                        <Col sm="4">
                          <Input
                            name="email"
                            className="form-control"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">パスワード</Label>
                        <Col sm="4">
                          <Input
                            name="password"
                            className="form-control"
                            type="password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Row className="mb-5">
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"受注ID"}
                    placeholder={""}
                    value={filter.orderNumber}
                    type="text"
                    name="orderNumber"
                    onChange={onChange}
                  />
                </Col>
                <Col lg={4}>
                  <Label>受注日</Label>
                  <div className="d-flex gap-2 align-items-center">
                    <DateInput
                      className="form-control"
                      onChange={val => {
                        setFilter({
                          ...filter,
                          orderDateFrom: moment(val[0]).format("YYYY-MM-DD"),
                        })
                      }}
                    />
                    <span>~</span>
                    <DateInput
                      className="form-control"
                      onChange={val =>
                        setFilter({
                          ...filter,
                          orderDateTo: moment(val[0]).format("YYYY-MM-DD"),
                        })
                      }
                      minDate={filter.orderDateFrom}
                    />
                  </div>
                </Col>
                <Col className="d-flex align-items-end">
                  <SButton className="mx-2 button" onClick={() => onSearch()}>
                    検索
                  </SButton>
                </Col>
              </Row>
              <Row className="mb-2">
                {data.loading ? (
                  <Skeleton count={5} />
                ) : data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
